export const sharedParamsConfig = {
  stringParams: [
    'api_host',
    'api_host_tracking',
    'api_host_tracking_legacy',
    'lang',
    'name',
    'theme',
    'type',
    'widget_id',
  ],
  boolParams: [],
  numberParams: [],
  enumParams: {},
} as const
// Unable to use `satisfies`. Need storybook 7+ to not break chromatic CI
// } as const satisfies ParamsConfig
